// extracted by mini-css-extract-plugin
export default {"cvError":"t8-z"};